import React, {useState, useEffect} from 'react'
import {Paper, Stepper, Step, StepLabel, Typography, CircularProgress, Divider, Button, CssBaseline} from '@material-ui/core';
import useStyles from './styles';
import {Link, useNavigate } from 'react-router-dom';
import AddressForm from '../AddressForm';
import PaymentForm from '../PaymentForm';
import {commerce} from '../../../lib/commerce';


const steps = ['Shipping address', 'Payment details'];

const Checkout = ({cart, order, onCaptureCheckout, error}) => {
    const [activeStep, setActiveStep] = useState(0);
    const classes = useStyles();
    const [shippingData, setShippingData] = useState({});
    const [checkoutToken, setCheckoutToken] = useState(null);
    const history = useNavigate();
    const [isFinished, setIsFinished] = useState(false);

    useEffect(() =>{
        const generateToken = async () =>{
            try {
                const token = await commerce.checkout.generateToken(cart.id, {type: 'cart'});

                
                setCheckoutToken(token);
            } catch (error) {
                history.push('/');
            }
        }

        generateToken();
    }, [cart, history]);

    const nextStep = () => setActiveStep((prevActiveStep) => prevActiveStep + 1);
    const backStep = () => setActiveStep((prevActiveStep) => prevActiveStep - 1);

    const next = (data) =>{
        setShippingData(data);

        nextStep();
    };

    const timeout = () => {
        setTimeout(() => {
            setIsFinished(true)
        }, timeout);
    }

    let Confirmation = () => order.customer ? (
        <br>
            <div>
                <Typography variant="h5" >Gracias por tu Compra, {order.customer.firstname} {order.customer.lastname}</Typography>
                <Divider className={classes.divider}/>
                <Typography varaint="subtitle2">Order ref: {order.customer.reference} </Typography>
            </div>
            <br />
            <Button component={Link} to="/"  varaint="outlined" type="button"> Back to Home</Button>

        </br>
    ) : isFinished ? (
        <>
        <div>
                <Typography variant="h5" >Gracias por tu Compra, </Typography>
                <Divider className={classes.divider}/>
                
            </div>
            <br />
            <Button component={Link} to="/"  varaint="outlined" type="button"> Back to Home</Button>
        </>
    ) : (
        <div className={classes.spinner}>
            <CircularProgress />
        </div>
    );

    if(error){
        <>
        <Typography varaint="h5"> Error: {error}</Typography>
        <br/>
        <Button component={Link} to="/"  varaint="outlined" type="button"> Back to Home</Button>
        </>
    }

    

    const Form = () => activeStep === 0
    ? <AddressForm checkoutToken={checkoutToken} next={next}/> 
    : <PaymentForm shippingData={shippingData} checkoutToken={checkoutToken} nextStep={nextStep} backStep={backStep} onCaptureCheckout={onCaptureCheckout} timeout={timeout}/>
  return (
    
        <>
            <CssBaseline />
            <div className={classes.toolbar}/>
            <main className={classes.layout}>
                <Paper className={classes.paper}> 
                    <Typography varaint="h4" align="center">Checkout</Typography>
                    <Stepper activeStep={activeStep} className={classes.stepper}>
                        {steps.map((step) =>(
                            <Step key={step}>
                                <StepLabel>{step}</StepLabel>
                            </Step>
                        ))}
                    </Stepper>
                    {activeStep === steps.length ? <Confirmation /> : checkoutToken && <Form />}
                </Paper>
            </main>
        </>
    
  )
}

export default Checkout
